import React from 'react'

function Phone() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="local_phone_24px" opacity="0.2">
        <path
          id="icon/maps/local_phone_24px"
          d="M19.2217 15.2676L16.6817 14.9776C16.0717 14.9076 15.4717 15.1176 15.0417 15.5476L13.2017 17.3876C10.3717 15.9476 8.05174 13.6376 6.61174 10.7976L8.46174 8.94758C8.89174 8.51758 9.10174 7.91758 9.03174 7.30758L8.74174 4.78758C8.62174 3.77758 7.77174 3.01758 6.75174 3.01758H5.02174C3.89174 3.01758 2.95174 3.95758 3.02174 5.08758C3.55174 13.6276 10.3817 20.4476 18.9117 20.9776C20.0417 21.0476 20.9817 20.1076 20.9817 18.9776V17.2476C20.9917 16.2376 20.2317 15.3876 19.2217 15.2676Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default React.memo(Phone)
